import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

const WorkSiteWBS: FunctionComponent = () => {
  return <Box data-cy="WorkSiteWBS">WorkSiteWBS</Box>;
};

export default WorkSiteWBS;
